/**
 * Converts a hex color code to an RGBA color string.
 *
 * @param hex - The hex color code (e.g., "#FFFFFF" or "#FFF").
 * @param opacity - The opacity value (0 to 1).
 * @returns The RGBA color string (e.g., "rgba(255, 255, 255, 0.5)").
 */
export const hexToRgba = (hex: string, opacity: number): string => {
  hex = hex.replace('#', '');

  // Expand shorthand hex (e.g., "03F" to "0033FF")
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((char) => char + char)
      .join('');
  }

  // Parse the hex color into RGB components
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  const alpha = Math.min(1, Math.max(0, opacity));

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
